'use strict';


var NAMESPACE = 'svp';

module.exports = function (name) {
	name = [NAMESPACE, name].join(':');

	var Debug = require('debug'),
		methods = {
		log: Debug(name + ':debug'),
		warn: Debug(name + ':warn'),
		error: Debug(name + ':error')
	};

	var debug = function () {
		methods.log.apply(this, arguments); // eslint-disable-line prefer-rest-params
	};
	debug.log = methods.log;
	debug.warn = methods.warn;
	debug.error = methods.error;
	debug.enable = function (expression) {
		if (!expression) {
			if (Debug.storage && Debug.storage.debug) {
				Debug.storage._prevDebug = Debug.storage.debug;
				expression = Debug.storage.debug + ', ' + NAMESPACE + '*';
			} else {
				expression = NAMESPACE + '*';
			}
		}

		Debug.enable(expression);
	};

	var regEx = new RegExp('^(.*?), ' + NAMESPACE + '\\*');
	debug.disable = function () {
		if (Debug.storage && Debug.storage._prevDebug) {
			var expression = Debug.storage._prevDebug.replace(regEx, '$1');
			Debug.storage._prevDebug = undefined;
			Debug.enable(expression);
		} else {
			Debug.disable();
		}
	};

	return debug;
};



// WEBPACK FOOTER //
// ./src/js/util/debug.js